import { Link } from "react-router-dom";

import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import Logo from "@/components/shared/Logo";
import { useI18n } from "@/lib/i18n";
import { buildFaqHomePath } from "@/lib/faq-route";

export default function FAQPage() {
  const { locale, tx } = useI18n();

  return (
    <div className="min-landing min-h-screen">
      <header className="landing-faq-page__nav">
        <div className="landing-faq-page__nav-inner">
          <Link to={buildFaqHomePath(locale)} aria-label={tx("Home")}>
            <Logo size="md" />
          </Link>
        </div>
      </header>
      <FAQ />
      <Footer />
    </div>
  );
}
